import React from "react";
import Footer from "../../components/Footer";

export default function BatchingFoundationsPurchase() {
  return (
    <>
      <main className="container-lg text-center py-5">
        <p>
          To view <strong>Batching Foundations</strong>, upgrade to Meal Plan Club, or buy the program, which includes 1 month of Meal Plan Club.
        </p>
        <a
          className="btn btn-primary"
          href="https://cleanfooddirtygirl.com/batching-foundations"
          target="_blank"
          rel="noopener noreferrer"
        >
          Check it out
        </a>
      </main>
      <Footer />
    </>
  );
}
